// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// ----------------------------------------------------
// Descomentar cuando se compile para pruebas:
// ----------------------------------------------------

/*
export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'http://localhost:4000',
  desarrolloApi: 'http://localhost:58797/extranet-api/',
  desarrolloDominio: 'http://localhost:4200/'
};
*/

// ----------------------------------------------------
// Descomentar cuando se compile para produccion:
// ----------------------------------------------------

export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'http://localhost:4000',
  desarrolloApi: 'https://apiextranetss.cmcsjt.com:8090/extranet-api/',
  desarrolloDominio: 'http://localhost:4200/'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
